export const MEMBER_TYPE_MAP = {
  young_member: { value: "young-member", label: "Young Members Circle" },
  corporate_young_member: { value: "young-member", label: "Young Members Circle" },
  member_in_transition: {
    value: "member-in-transition",
    label: "Member in Transition",
  },
  member: { value: "member", label: "Member" },
  corporate_member: { value: "member", label: "Member" },
  "non-member": { value: "non-member", label: "Non-Member" },
};

export function getMemberTypeLabel(type = "non-member") {
  if (type === "pending") return "Ticket";
  const mapped = MEMBER_TYPE_MAP[type];
  return mapped?.label ?? type;
}

export default function MemberType({ type = "non-member" }) {
  if (type === "pending") return null;
  const mapped = MEMBER_TYPE_MAP[type];
  const typeValue = mapped?.value ?? type;
  const typeLabel = mapped?.label ?? type;

  return (
    <span className={`member-type member-type__${typeValue}`}>{typeLabel}</span>
  );
}
